import React, { Component } from 'react'

export class Contadores extends Component {

   
    render() {
      

      function contadores(s) {
        const styles = (s.presion===null) ? {display: 'none'}:{};
         return (
          <section className="dashboard-counts section-padding">
          <div className="container-fluid">
            <div className="row">
              
              <div className="col-xl-3 col-md-4 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Cota msnm</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.cota===null)?'null':(s.cota)}</div>
                  </div>
                </div>
              </div>
             
              <div className="col-xl-3 col-md-4 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Temperatura ºC</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.temperatura===null)?'null':(s.temperatura)}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-4 col-6" style={styles}>
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Presión cm H2O</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.presion===null)?'null':(s.presion)}</div>
                  </div>
                </div>
              </div>
              
              <div className="col-xl-3 col-md-4 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Fecha y Hora</strong><span>Última Lectura</span>
                    <div className="count-number">{s.fechalec}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-3 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Temperatura Eagle C°</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.temp_equipo===null)?'null':(s.temp_equipo)}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-3 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Batería V</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.bateria===null)?'null':(s.bateria)}</div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-md-3 col-6">
                <div className="wrapper count-title d-flex">
                  <div className="icon"><i className="icon-padnote"></i></div>
                  <div className="name"><strong className="text-uppercase">Nivel de Señal dBm</strong><span>Última Lectura</span>
                    <div className="count-number">{(s.senal===null)?'null':(-1*s.senal)}</div>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </section>
      )
        
      }

      return contadores(this.props.lecturas);
        
    }
}

export default Contadores
